import React from 'react'

import { Hero, ContextType, convertSize } from '@sketch/discover'

import { Grid } from '@sketch/components'
import CommunityPublicationListing from '../CommunityPublicationListing'
import CommunityPublicationGrid from '../CommunityPublicationGrid'
import CommunityPublicationSlider from '../CommunityPublicationSlider'
import {
  CommunityHeroFragment,
  CommunityPublicationQueryFragment,
  ItemFragment,
} from '@sketch/gql-types'

// Types

export interface EditorialItemProps {
  item: ItemFragment | CommunityHeroFragment | CommunityPublicationQueryFragment
  context: ContextType
}

// Helpers
const COMPONENTS_BY_TYPE = {
  CommunityHero: Hero,
  CommunityListing: CommunityPublicationListing,
  CommunityGrid: CommunityPublicationGrid,
  CommunitySlider: CommunityPublicationSlider,
}

/**
 * EditorialItem
 *
 * Responsible for rendering the content of Sections for the Community page
 */
const EditorialItem: React.FC<EditorialItemProps> = ({ item, context }) => {
  // We don't want to render any Discover item in this component
  if (item.__typename === 'Item') {
    return null
  }

  if (item.__typename === 'CommunityHero') {
    return (
      <Grid.Column key={item.id} {...convertSize(item.size)}>
        <Hero {...item} context={context} />
      </Grid.Column>
    )
  }

  const Component = COMPONENTS_BY_TYPE[item.__typename]

  return (
    <Grid.Column key={item.id}>
      <Component {...item} />
    </Grid.Column>
  )
}

export default EditorialItem
